function c(n) {
  var o;
  const e = /* @__PURE__ */ new Map();
  for (const t of n) {
    const s = t.pos[1];
    e.has(s) ? (o = e.get(s)) == null || o.push(t) : e.set(s, [t]);
  }
  return e;
}
export {
  c as getObjectsByLevel
};
//# sourceMappingURL=index11.js.map
